import { render, staticRenderFns } from "./calendar-deadlines.vue?vue&type=template&id=26d28a9c&"
import script from "./calendar-deadlines.vue?vue&type=script&lang=ts&"
export * from "./calendar-deadlines.vue?vue&type=script&lang=ts&"
import style0 from "./calendar-deadlines.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports